import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            onClick={scrollToTop}
            className={`fixed bottom-4 right-4 p-3 bg-zinc-900 text-white rounded-full shadow-lg transition-opacity z-50 ${isVisible ? 'opacity-100' : 'opacity-0'} hover:bg-black hover:scale-105 transition-all ease-in-out duration-700`}
            style={{ pointerEvents: isVisible ? 'auto' : 'none' }}
            aria-label="Scroll to top"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill='white'><path d="M12 2a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8z"/><path d="m7.293 13.293 1.414 1.414L12 11.414l3.293 3.293 1.414-1.414L12 8.586l-4.707 4.707z"/></svg>
        </button>
    );
};

export default ScrollToTopButton;
